import HttpRequest from '@/utils/request.js';
// import md5 from 'js-md5';

const request = {
        'newsList': '/notice/list', // 获取新闻列表
        'sendCode': '/apptInfo/sendCode', //发送验证码
        'booking': '/apptInfo/submit', //提交预约
        'getNewsPic1': '/ad/list/1', //获取轮播图
        'getNewsPic0': '/ad/list/0' //获取轮播图
    },
    httpRequest = new HttpRequest(),
    operate =  'https://fanyukaitian.com.cn/api', //  '/api', // 'http://106.54.232.139/api' notice/list?noticeType=2
    paramsStrSort = (paramsStr) => { // 2HMKIQ92QdPdBL6epua9XatDjWqPwd3hwgl4J41eP5X
        // console.log( paramsStr );
        const  url = paramsStr.split('&').sort().join('&'),
            urlStr = url;
        return url;
    },
    getSign = (param) => {
        if (typeof param === 'object') {
            const arr = [];
            for (const i in param) {
                /*if ( !['undefined', 'null', ''].includes( String( param[i] ) ) ) {
                    arr.push( i + '=' + param[i] );
                }*/
                arr.push(i + '=' + param[i]);
            }
            return paramsStrSort(arr.join('&'));
        }
    },
    header = (params) => {
        return {
            sign: getSign(params),
            Authorization: window.sessionStorage.getItem("token"),
            'Content-Type': 'application/x-www-form-urlencoded'
        };
    };

export default {
    sendRequest(name, params, callback) {
        //console.log( params );
        httpRequest.postRequest(operate + request[name], params, callback);
    },
    sendGetRequest(name, params, callback) {
        //console.log( params );
        httpRequest.getRequest(operate + request[name], params, callback);
    },
};




// WEBPACK FOOTER //
// ./src/api/home-api.js